module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_diamond_brown.ebc16a7e.png";